<div
  class="bg-center bg-no-repeat bg-cover box-footer"
  style="background-image: url('assets/images/textura.webp')"
  *ngIf="config$ | async as config"
>
  <div class="margin-responsive">
    <div class="footer">
      <ul class="footer__group">
        <li class="footer__group__title">{{ 'global.links' | translate }}</li>

        <li *ngFor="let item of config.plugin.handler.scaffold.institutional">
          <a [href]="item.href" target="_blank">{{ item.alt | translate }}</a>
        </li>
        <li>
          <a [href]="config.plugin.handler.scaffold.privacyUrl(config.school)" target="_blank">
            {{ 'global.privacy' | translate }}
          </a>
        </li>
      </ul>

      <ul class="footer__group">
        <li class="footer__group__title">{{ 'global.access' | translate }}</li>

        <li>
          <a routerLink="/">{{ 'global.home' | translate }}</a>
        </li>
        <li *ngIf="config.school.isSobre">
          <a routerLink="/about"> {{ 'menu.about' | translate }} </a>
        </li>
        <li *ngIf="config.school.isEquipe">
          <a routerLink="/team"> {{ 'menu.team' | translate }} </a>
        </li>
        <li>
          <ng-container *ngIf="enrolment$ | async as enrolment">
            <ng-container *ngIf="!!enrolment.data; else runnableTemplate">
              <a [href]="enrolment.data" target="_blank">
                {{ 'menu.enrollments' | translate }}
              </a>
            </ng-container>
            <ng-template #runnableTemplate>
              <a (click)="onSchedule()">
                {{ 'menu.enrollments' | translate }}
              </a>
            </ng-template>
          </ng-container>
        </li>
        <li *ngIf="config.school.url_ver_por_dentro">
          <a [href]="config.school.url_ver_por_dentro" target="_blank">
            {{ 'menu.tour' | translate }}
          </a>
        </li>
      </ul>

      <ul class="footer__group">
        <li class="footer__group__title">{{ 'connections.connections' | translate }}</li>

        <li *ngFor="let item of config.plugin.handler.scaffold.connections">
          <a [href]="item.href" target="_blank">{{ item.alt | translate }}</a>
        </li>
      </ul>

      <ul class="footer__group">
        <li class="footer__group__title">{{ 'connections.contact' | translate }}</li>

        <li *ngIf="!!config.school.endereco">
          <span>{{ config.school.endereco }}</span>
        </li>
        <li *ngIf="!!config.school.cidade">
          <span>{{ config.school.cidade }} - {{ config.school.uf }}</span>
        </li>
        <li *ngIf="!!config.school.cep">
          <span>
            {{ 'connections.cep' | translate }}:
            {{ config.school.cep | mask: config.plugin.handler.home.applyPostalCodeMask(config.school.cep) }}
          </span>
        </li>
        <li *ngIf="!!config.school.telefone">
          <a [href]="phoneLink(config.school)">
            {{ 'connections.telephone' | translate }}:
            {{ config.school.telefone | mask: config.plugin.handler.home.applyPhoneMask(config.school.telefone) }}
          </a>
        </li>
        <li *ngIf="!!config.school.whatsapp">
          <a [href]="whatsLink(config.school)" target="_blank">
            {{ 'connections.whatsapp' | translate }}:
            {{ config.school.whatsapp | mask: config.plugin.handler.home.applyPhoneMask(config.school.whatsapp) }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Copyright -->
    <div class="copyright">
      <span>{{ now | date: 'YYYY' }} © {{ 'global.rodape' | translate }}</span>
      <!-- Social Networks -->
      <app-labels-social-networks></app-labels-social-networks>
      <span>{{ 'global.version' | translate }} {{ version }}</span>
    </div>
  </div>
</div>
